var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_vm._v(" 繳費正在開發中 ")])}
var staticRenderFns = []

export { render, staticRenderFns }